import { render, staticRenderFns } from "./import.vue?vue&type=template&id=b62cb226&scoped=true"
import script from "./import.vue?vue&type=script&lang=js"
export * from "./import.vue?vue&type=script&lang=js"
import style0 from "./import.vue?vue&type=style&index=0&id=b62cb226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62cb226",
  null
  
)

export default component.exports